"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const networkStatus_1 = require("apollo-client/core/networkStatus");
exports.queryIsLoading = (queryResult) => {
    return !queryResult
        ? false
        : queryResult.loading ||
            networkStatus_1.isNetworkRequestInFlight(queryResult.networkStatus);
};
//# sourceMappingURL=queryIsLoading.js.map